export default __webpack_public_path__ + "static/media/hostaway_step9.52f57827.jpg";